export default {
    namespace: 'entities',

    store: null,
    state: {},

    /**
     * Register Model
     */
    register(model) {
        if(typeof model === 'object' && model !== null) {
            this.state[model.entity] = { data: [] }
        } else {
            this.state[model] = { data: [] }
        }
    },

    /**
     * Install Vuex Plugin
     */
    plugin() {
        return store => {
            this.store = store
            store.registerModule(this.namespace, this.createVuexModule())
        };
    },

    /**
     * Create Vuex Module
     */
    createVuexModule() {
        const mutations = {
            init(state, payload) {
                if(!payload || !payload.model || !payload.data) return

                const ModelClass = payload.model
                state[ModelClass.entity].data = payload.data
                    .filter(modelData => !!modelData)
                    .map(modelData => new ModelClass(modelData))
            },
            create(state, payload) {
                if(!payload || !payload.model || !payload.data) return

                const ModelClass = payload.model
                state[ModelClass.entity].data = payload.data
                    .filter(modelData => !!modelData)
                    .map(modelData => new ModelClass(modelData))
            },
            insert(state, payload) {
                if(!payload || !payload.model || !payload.data || !payload.data.length) return

                const ModelClass = payload.model
                const storedModels = state[ModelClass.entity].data

                const storedModelsMap = new Map()
                storedModels.forEach(model => storedModelsMap.set(model[ModelClass.primaryKey], model))

                payload.data.forEach(modelData => {
                    if(modelData) {
                        storedModelsMap.set(modelData[ModelClass.primaryKey], new ModelClass(modelData))
                    }
                })

                state[ModelClass.entity].data = [...storedModelsMap.values()];
            },
            update(state, payload) {
                if(!payload || !payload.model || !payload.data || !payload.data.length) return

                const ModelClass = payload.model
                const storedModels = state[ModelClass.entity].data

                const storedModelsMap = new Map()
                storedModels.forEach(model => storedModelsMap.set(model[ModelClass.primaryKey], model))

                payload.data.forEach(modelData => {
                    const key = modelData ? modelData[ModelClass.primaryKey] : null
                    if(key && storedModelsMap.has(key)) {
                        const updatedModelData = { ...storedModelsMap.get(key).$toJson(), ...modelData }
                        storedModelsMap.set(key, new ModelClass(updatedModelData))
                    }
                })

                state[ModelClass.entity].data = [...storedModelsMap.values()];
            },
            delete(state, payload) {
                if(!payload || !payload.model || !payload.data) return

                const ModelClass = payload.model
                const storedModels = state[ModelClass.entity].data.filter(model => model[ModelClass.primaryKey] !== payload.data[ModelClass.primaryKey])

                state[ModelClass.entity].data = storedModels;
            }
        };

        const getters = {
            all: (state) => (entity) => {
                return state[entity].data;
            },
            find: (state) => (entity, primaryKey, id) => {
                return state[entity].data.find(model => model[primaryKey] == id);
            }
        }

        return {
            namespaced: true,
            state: this.state,
            mutations: mutations,
            getters: getters,
        }
    }
}
